import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { URL } from '@app-shared/constants/service-urls';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  constructor(private api: ApiService) { }

  downloadSampleFile(data: any) {
    let queryUrl = `${URL.ADMIN.DOWNLOAD_SAMPLE_FILE}?sampleOf=${data.type}&question_type=${data.question_type}&language=${data.language}`;
    if (data.type === 'users' && data.items?.categoryId) {
      queryUrl += `&user_category_id=${data.items.categoryId}`;
    }
    if (data.courseName) {
      queryUrl += `&courseName=${encodeURIComponent(data.courseName)}`;
    }
    if (data.courseCode) {
      queryUrl += `&courseCode=${encodeURIComponent(data.courseCode)}`;
    }
    if (data.courseVersion) {
      queryUrl += `&courseVersion=${encodeURIComponent(data.courseVersion)}`;
    }
    return this.api.get(queryUrl, { responseType: 'blob' });
 };
 
}
